import { addCollection } from '@iconify/vue'

export async function registerIcons() {
  const modules = import.meta.glob('../assets/icons/**/*.svg', {
    query: '?raw',
    import: 'default',
  })

  for (const path in modules) {
    try {
      const svg = (await modules[path]()) as string
      const match = path.match(/icons\/(.*?)\/(.*?)\.svg$/)
      if (!match) continue

      // eslint-disable-next-line
      const [_, prefix, name] = match

      // Extract license comment
      const licenseComment = svg.match(/<!--.*?-->/s)?.[0] || ''

      // Extract path data with preserved comment
      const pathMatch = svg.match(/<path[^>]*d="([^"]*)"[^>]*>/)
      const pathData = pathMatch ? pathMatch[0] : ''
      const viewBoxMatch = svg.match(/viewBox="([^"]*)"/)
      const viewBox = viewBoxMatch ? viewBoxMatch[1] : '0 0 24 24'
      const [, , width, height] = viewBox.split(' ').map(Number)

      addCollection({
        prefix,
        icons: {
          [name]: {
            body: `${licenseComment}${pathData}`,
            width,
            height,
          },
        },
        width,
        height,
      })
    } catch (err) {
      console.error(`Failed to register icon ${path}:`, err)
    }
  }
}
